import { IFullCardData } from "domains/cashless/aggregates/ICardCashless";
import { ICefSharpCardReader } from "Infrastructure/services/cefSharpService/local/Interfaces/ICefSharpCardReader";
import { IOfflineCardData } from "modules/cardReader/domain/models/IOfflineCardData";
import { addListenerOnCardRemoved, writeOfflineBalance, writeOfflineCard } from "modules/reactNativeBridge/ReactNativeBridge";

declare const rfidService: ICefSharpCardReader;



export const ReactNativeCardReader = (): ICefSharpCardReader => {
  const enableCardReader = async () => {
    addListenerOnCardRemoved(() => {
      window.onRemovedCard();
      });
   
  };

  const writeBalance = async (tag: string, rechargeValue: number): Promise<void> => {
    const valueCents = Math.round(rechargeValue);
    // await window.RNBridge.callNative("writeBalance", { tag, rechargeValue });
    console.log("writeBalance", tag, valueCents);
    await writeOfflineBalance( tag, valueCents);
  };

  const writeCardData = async (data: IOfflineCardData): Promise<void> => {
    const dataWithIntegerBalance: IOfflineCardData = {
      ...data,
      Balance: Math.round(data.Balance),
    };
    console.log("[ReactNativeCardReader] writeCardData", dataWithIntegerBalance);
    await writeOfflineCard(dataWithIntegerBalance);
  };

  const setBalance = async (rechargeValue: number) => {
  
  };

  const setReadError = async (errorMessage: string) => {
   
  };

  const onDetectedCard = () => {
   
  };

  const onRemovedCard = () => {
   
  };

  return {
    startCardReader: enableCardReader,
    writeBalance,
    writeCardData,
    setCardBalance: setBalance,
    setReadError,
    onDetectedCard,
    onRemovedCard,
  };
};

